import { render, staticRenderFns } from "./TenantConfirmModal.vue?vue&type=template&id=22d76fb4&"
import script from "./TenantConfirmModal.vue?vue&type=script&lang=js&"
export * from "./TenantConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d76fb4')) {
      api.createRecord('22d76fb4', component.options)
    } else {
      api.reload('22d76fb4', component.options)
    }
    module.hot.accept("./TenantConfirmModal.vue?vue&type=template&id=22d76fb4&", function () {
      api.rerender('22d76fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ccd/TenantConfirmModal.vue"
export default component.exports